import React from 'react';

const CardComponent = ({ 
  colSize = 'col-md-12', 
  title, 
  subtitle, 
  children 
}) => {
  return (
    <div className="row">
      <div className={colSize}>
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div>
              {title && <h6 className="card-title mb-1">{title}</h6>}
              {subtitle && <p className="text-muted card-sub-title">{subtitle}</p>}
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardComponent;